import { useState, useRef, useEffect } from 'react'
import { parseDate } from '../utils/date.util'

function useCounter(dateString) {
	const [counter, setCounter] = useState({
		days: 0,
		hours: 0,
		min: 0,
		sec: 0,
	})
	const counterRef = useRef(null)

	useEffect(() => {
		const date = parseDate(dateString)

		// Check if date is valid
		if (!date || isNaN(date.getTime())) {
			console.warn('Invalid date provided to useCounter:', dateString)
			return
		}

		counterRef.current = setInterval(() => {
			const now = new Date()
			const diff = date - now + 24 * 60 * 60 * 1000

			// Ensure diff is not negative (event has passed)
			const safeDiff = Math.max(0, diff)

			if (typeof setCounter === 'function')
				setCounter((c) => ({
					days: Math.floor(safeDiff / 1000 / 60 / 60 / 24),
					hours: Math.floor((safeDiff / 1000 / 60 / 60) % 24),
					min: Math.floor((safeDiff / 1000 / 60) % 60),
					sec: Math.floor((safeDiff / 1000) % 60),
				}))
		}, 1000)
		return () => {
			clearInterval(counterRef.current)
		}
	}, [dateString])

	return counter
}

export default useCounter
